import { useResource } from '@invisible-cms/react'
import React, { memo, useState, useEffect, useRef } from 'react'
import { Event } from '../../domain/event'

import { ProgrammeGrid, ProgrammeCell } from '../molecules/progamme-cell'
import { useSetState, usePrevious } from 'react-use'
import { times, flatten } from 'lodash'
import { Rows, spacingLevel, Text } from '../../design-system'
import { useScrollSpy } from '../../services'
import { lightTheme2019 } from '../theme'
import { ChipButton } from '../atoms'

interface ProgrammeSearchResultsProps {
  tags: string[]
  text: string
}

export const ProgrammeSearchResults = memo(
  ({ tags, text }: ProgrammeSearchResultsProps) => {
    const [page, setPage] = useState(0)

    // Reset to page zero when the search changes
    useEffect(() => {
      setPage(0)
    }, [tags, text])

    const pageEvents = useResource(Event.search, {
      festival: '2019',
      tags,
      text,
      page,
    })

    // Page data store
    const [pageData, setPageData] = useState({
      [page]: pageEvents && pageEvents.value,
    })

    // Clear the page data store when the search changes
    useEffect(() => {
      setPageData({})
    }, [tags, text])

    // Clear the page data store when the search changes
    useEffect(() => {
      if (
        pageEvents &&
        !Object.values(pageData).some(
          x =>
            x[0] && pageEvents.value[0] && x[0].id === pageEvents.value[0].id,
        )
      ) {
        setPageData({ ...pageData, [page]: pageEvents && pageEvents.value })
      }
    }, [page, pageEvents])

    const events = flatten(times(page + 1, i => pageData[i] || []))
    const isLast = pageData[page] && pageData[page].length < 10
    console.log(pageData)
    return (
      <>
        <ProgrammeGrid>
          {events.map(e => (
            <ProgrammeCell key={e.id} event={e} />
          ))}
        </ProgrammeGrid>
        {!isLast && (
          <Rows alignItems="center">
            <ChipButton
              paddingVertical={2}
              paddingHorizontal={3}
              color="contentAlt"
              onClick={() => setPage(page + 1)}
            >
              <Text variant="controlContent">Load More…</Text>
            </ChipButton>
          </Rows>
        )}
      </>
    )
  },
)
